export default __webpack_public_path__ + "static/media/desktop.0b0f01dd.jpg";